// extracted by mini-css-extract-plugin
export default {"login-toast":"login-toast-component_login-toast__FzLya","toast-content":"login-toast-component_toast-content__qqREf","user":"login-toast-component_user__YGwL1"};